<script setup>

import KdContainer from "./kdContainer.vue";
import KdTempSolutionForm from "./kdTempSolutionForm.vue";
</script>

<template>
  <kd-container>
    <el-form label-width="142px" :model="form" :rules="rules" ref="formRef">
      <div v-if="this.taskDefKey == 'Activity_1jmu1ad'"> <!-- 只回填 -->
        <el-form-item label="问题类型" prop="problemType">
          <el-radio-group v-model="form.problemType" disabled>
            <el-radio label="0">质量中心</el-radio>
            <el-radio label="1">海外运营支持中心</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
      <div v-else>
        <el-form-item label="问题类型" prop="problemType">
          <el-radio-group v-model="form.problemType">
            <el-radio label="0">质量中心</el-radio>
            <el-radio label="1">海外运营支持中心</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
      <el-form-item>
        <el-button class="lang-but" type="primary" @click="auditPassBtClick(0)">通过</el-button>
        <el-button class="lang-but" type="danger" @click="auditRejectBtClick">驳回</el-button>
        <el-button v-show="taskDefKey == 'Activity_1jmu1ad'" plain @click="auditPassBtClick(1)">申请结束流程</el-button>
      </el-form-item>
    </el-form>

    <!-- 审核通过意见弹窗 -->
    <kd-audit-pass-dialog
      :visible.sync="auditPassDialogVisible"
      v-model="form.auditText"
      @confirm="onAuditPassConfirm"
    />

    <div>
      <el-dialog width="600px !important" title="审核驳回" :visible.sync="dialogVisible">
        <el-form :model="form" :rules="rules" ref="rejectFormRef" label-width="85px">
          <el-form-item label="驳回原因" prop="rejectReason">
            <el-input v-model="form.rejectReason" type="textarea" placeholder="请输入驳回原因" :autosize="{ minRows: 4, maxRows: 4 }" maxlength="500" show-word-limit></el-input>
          </el-form-item>
          <div class="submitArea">
            <el-button type="primary" @click="auditRejectSubmit()">提交</el-button>
            <el-button plain  @click="dialogVisible = false">取消</el-button>
          </div>
        </el-form>
      </el-dialog>
    </div>
  </kd-container>
</template>

<style scoped lang="scss">
</style>
<script>
import {requestSubmitAuditKD} from "@/api/feedbackKD";
import KdAuditPassDialog from "./kdAuditPassDialog.vue";

/**
 * 问题类型审核表单
 */
export default {
  name: "kdSolutionAudit",
  inject: ['getValidateForm'],
  components: { KdAuditPassDialog },
  props: {
    taskId:String,
    questionId:String,
    taskDefKey:String,
    problemType:String
  },
  data() {
    return {
      type: "",
      dialogVisible:false,
      auditPassDialogVisible: false,
      form:{
        problemType: "",
        rejectReason:"",
        auditText:"",
      },
      rules: {
        problemType: [
          {
            required: true, message: "问题类型不能为空", trigger: ["blur", "change"]
          }
        ],
        rejectReason: [
          {
            required: true, message: "驳回原因不能为空", trigger: ["blur", "change"]
          }
        ]
      }
    }
  },
  watch: {
    hasTempSolution: function (val) {
      this.$emit("hasTempSolution", val);
    }
  },
  methods: {
    async auditPassBtClick(type) {
      this.type = type;
      if (!await this.getValidateForm()) {
        return
      }
      this.$refs['formRef'].validate((valid, object) => {
        if (this.getRequiredValid(valid, object)){
          return
        }
        this.auditPassDialogVisible = true;
      })
    },
    onAuditPassConfirm(auditText) {
      let formData = {
        nowTaskId: this.taskId,
        questionId: this.questionId,
        taskDefKey: this.taskDefKey,
        auditText: auditText,
        variables: {
          approval: true,
          problemType: this.form.problemType,
          type: this.type
        },
      }
      requestSubmitAuditKD(formData).then(res => {
        if (res.status == "0") {
          this.$DonMessage.success('审批通过!');
          this.backRouterPath();
        } else {
          this.$DonMessage.error(res.message);
        }
      })
    },
    auditRejectBtClick() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.rejectFormRef?.resetFields();
      })
    },
    auditRejectSubmit(){
      this.$refs['rejectFormRef'].validate((valid, object) => {
        if (this.getRequiredValid(valid, object)){
          return
        }
        let formData = {
          nowTaskId: this.taskId,
          questionId: this.questionId,
          taskDefKey: this.taskDefKey,
          auditText: this.form.rejectReason,
          variables: {
            approval: false
          },
        }
        requestSubmitAuditKD(formData).then(res => {
          if (res.status == "0") {
            this.$DonMessage.success('驳回成功!');
            this.dialogVisible = false;
            this.backRouterPath();
          } else {
            this.$DonMessage.error(res.message);
          }
        })
      })

    }
  },mounted() {
    this.form.problemType = this.problemType || "";
  }
}
</script>
